import React, { Component }        from "react";
import { Button, PageHeader, Col } from "react-bootstrap";
import Iframe                      from 'react-iframe'
import uniqueId                    from 'lodash/uniqueId';
import config                      from "../../config";
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import { Colors }                  from "../../utils/Colors";
import { WhiteLabel }              from "../../utils/WhiteLabelProps";
import "../../css/utils/Settings.css";


var company_id  = sessionStorage.getItem('company_id');
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

export default class Scheduler extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            //this.settings();
        } catch (e) {
            alert(e);
        }
    }

    renderHome() {
        var no_acct;

        if(company_id != posture_health_company_id) {
            no_acct = <div>
                        If you don't have a Zoom account, contact us at <a href="mailto:info@trainingslate.com">info@trainingslate.com</a> and we'll help set you up.
                      </div>
        }

        return (
              <div className="programs">
                <PageHeader>
                    <FontAwesomeIcon icon="calendar-alt" className="" style={{ color: Colors.primary_color, fontSize: '1.45em', paddingRight:"16px" }}/>
                    <span style={{position: "relative", top:-5}}>
                        Scheduler
                    </span>
                </PageHeader>
                {no_acct}
              </div>
        );
    }

    render() {
        return (
              <div className="Home">
                {this.renderHome() }
                <iframe src="https://app.acuityscheduling.com/schedule.php?owner=21183327" title="Schedule Appointment" width="100%" height="800" frameBorder="0"></iframe><script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/scheduler/Scheduler.js